import React from 'react';
import {Address, Maybe} from '../schema'
import {addressToLines} from "../models/utils/Addresses";

type Props = {
  type: string
  address?: Maybe<Address>
  className?: string,
}

export default function AttendeeAddress({type, address, className}: Props) {
  if (!address) {
    return (<span>—</span>)
  }

  const lines = addressToLines(address)

  return (<span className={className}>{lines.map((line, index) => (
    <span key={`${type}_${index}`}>{line}<br/></span>))}</span>);
}
